import { FormattedDate } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandXS } from '@sorare/core/src/atoms/typography';
import { HeadlinePill } from '@sorare/core/src/components/animations/AnimatedStory/HeadlinePill';

type Props = {
  startDate: Date;
  endDate: Date;
  colors?: { bg: string; fg: string };
};
export const GameweekDate = ({ startDate, endDate, colors }: Props) => {
  return (
    <HeadlinePill
      label={
        <Horizontal gap={0.5}>
          <BrandXS>
            <FormattedDate value={startDate} month="short" day="numeric" />
          </BrandXS>
          <BrandXS>-</BrandXS>
          <BrandXS>
            <FormattedDate value={endDate} month="short" day="numeric" />
          </BrandXS>
        </Horizontal>
      }
      colors={colors}
    />
  );
};
